const toLocalISOString = require('../../../common/utility/data-toLocalIsoString');

module.exports = function (shopperService, checkoutService, $rootScope, storePickerService, collectionTimeService) {
    return {
        restrict: 'EA',
        scope: {
            isUnavailableProducts: '=',
            title: '@',
            hasBackOrderProduct: '<',
            hasPreOrderProduct: '<',
            preOrderMarketReleaseDate: '<'
        },
        link(scope) {

            function _init() {
                scope.backOrderPickUpDateFormatted = collectionTimeService.calculateBackorderPickupDate();
                const backorderBufferDays = storePickerService.fulfilmentInfo.ClickAndCollectDetails.DaysToFulfillBackOrder;
                scope.backOrderPickUpDate = null;
                if (scope.hasBackOrderProduct) {
                    const date = new Date();
                    date.setDate(date.getDate() + backorderBufferDays);
                    scope.backOrderPickUpDate = toLocalISOString(date);
                }

                //this api call is mandatory - to get user selection from server
                shopperService.getIncludeBackOrder().then((response) => {
                    scope.isBackOrderSelected = response.IncludeBackOrder;
                    scope.radio = {
                        value: (scope.isBackOrderSelected || scope.hasPreOrderProduct) ? 'Later' : 'Today'
                    };
                    scope.collectionTimes = [
                        {
                            time: 'Today',
                            timeDetails: 'Available now',
                            timeDescription: '<p>Your Order will be available within 30 minutes</p>',
                            selected: !scope.isBackOrderSelected && !scope.hasPreOrderProduct
                        },
                        {
                            time: 'Later',
                            timeDetails: `Ready in ${backorderBufferDays} days`,
                            timeDescription: `<p>Your order will be ready by</p>
                        <time class="alert--highlight-text">${scope.backOrderPickUpDateFormatted}</time>
                        <p>Need your order earlier? Select 'Today' to purchase what\'s currently available in BWS ${storePickerService.fulfilmentInfo.ClickAndCollectDetails.FulfilmentStoreName}</p>`,
                            selected: scope.isBackOrderSelected || scope.hasPreOrderProduct
                        }
                    ];
                });
            }

            _init();

            scope.updateCollectionTime = function (time) {

                scope.radio.value = time;
                scope.disableLater = false;

                const showBackOrder = time !== 'Today';

                angular.forEach(scope.collectionTimes, (item) => {
                    item.selected = false;

                    item.selected = item.time === scope.radio.value;
                });

                shopperService.setIncludeBackOrder(showBackOrder).then(function () {
                    checkoutService.setIsTotalReady(false);
                    checkoutService.invalidateCheckoutModel();
                    $rootScope.$broadcast('trolley:update');
                });
            };

            scope.$watch('isUnavailableProducts', function () {
                scope.disableLater = scope.radio && scope.radio.value === 'Today' && !scope.isUnavailableProducts;
            });

            scope.$on('store:updated', function () {
                _init();
            });
        },
        template: require('./collection-time-switch-template.html').trim()
    };

};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collection-time-switch/collection-time-switch-directive.js
 **/